import React, { useEffect, useState } from "react";
import { TypeAnimation } from "react-type-animation";
import { IoSearch } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";

const Search = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSearchPage, setIsSearchPage] = useState(false);

  useEffect(() => {
    setIsSearchPage(location.pathname === "/search");
  }, [location]);

  const redirectToSearchPage = () => {
    navigate("/search");
  };

  return (
    <div className="relative w-1/2 max-w-lg">
      {/* Search Icon */}
      <button
        onClick={redirectToSearchPage}
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
      >
        <IoSearch size={22} />
      </button>

      {/* If NOT on search page → Show animation */}
      {!isSearchPage && (
        <div
          onClick={redirectToSearchPage}
          className="absolute w-full h-full inset-y-0 left-10 flex items-center text-gray-400 cursor-text"
        >
          <TypeAnimation
            sequence={[
              "Search cabinets...",
              1500,
              "Find kitchen ideas...",
              1500,
              "Explore Acrylic designs...",
              1500,
            ]}
            wrapper="span"
            cursor={true}
            repeat={Infinity}
          />
        </div>
      )}

      {/* If ON search page → Show real input */}
      {isSearchPage && (
        <input
          type="text"
          placeholder="Search for cabinets"
          className="w-full bg-transparent pl-10 pr-4 py-2 rounded-full border border-gray-300 focus:ring-2 focus:ring-indigo-400 focus:outline-none transition-all"
          autoFocus
        />
      )}
    </div>
  );
};

export default Search;
